<template>
  <div class="layout-body">
    <div class="layout-header-bar">
      <div class="head-logo">
        <img src="@assets/img/exhibition/logo.png" alt="云展台" @click="$router.push('/exhibition/index/home')" class="f-csp"/>
      </div>
      <div class="head-right">
        <div class="head-btn" @click="back">返回</div>
      </div>
    </div>
    <div class="layout-box">
      <div class="register-form">
        <div class="rf-title">公司信息</div>
        <Form
          ref="formInline"
          :model="formInline"
          :rules="ruleInline"
          label-position="right"
          :label-width="150"
          @submit.native.prevent
        >
          <FormItem label="公司全称：" prop="name">
            <Input type="text" v-model="formInline.name" placeholder="请输入公司全称" />
          </FormItem>
          <FormItem label="公司简称：" prop="shortName">
            <Input type="text" v-model="formInline.shortName" placeholder="请输入公司简称" />
          </FormItem>
          <FormItem label="公司地址：" prop="addr">
            <Input type="text" v-model="formInline.addr" placeholder="请输入公司地址" />
          </FormItem>
          <FormItem label="公司logo：" prop="logo">
            <div class="my-upload">
              <div
                class="my-upload-list"
                v-for="(item, index) in uploadList"
                :key="'upload' + index"
              >
                <template v-if="item.status === 'finished'">
                  <img :src="item.url" style="height: 100px;width: 100px;" />
                  <div class="my-upload-list-cover">
                    <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                    <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                  </div>
                </template>
                <template v-else>
                  <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                </template>
              </div>
              <Upload
                ref="upload"
                :show-upload-list="false"
                :default-file-list="defaultList"
                :on-success="handleSuccess"
                :format="['jpg','jpeg','png']"
                :max-size="2048"
                :headers="formHeaders"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                type="drag"
                :action="uploadUrl"
                multiple
                :before-upload="handleBeforeUpload"
                style="display: inline-block;width:100px;"
              >
                <div style="width: 100px;height:100px;padding-top: 20px;">
                  <div>
                    +
                    <br />
                    <p>上传</p>
                  </div>
                </div>
              </Upload>
            </div>
            <div class="my-upload-tip">（图片要求：2M以下的jpg或png，建议尺寸为高度40px，比例1:1）</div>
          </FormItem>
          <!-- <customFormType v-model="formData"></customFormType> -->
          <!-- <FormItem>
            <Button
              type="primary"
              size="large"
              @click="handleSubmit('formInline')"
              :loading="loading"
              long
            >提交</Button>
          </FormItem>-->
        </Form>
      </div>
    </div>
    <div class="layout-box z-top">
      <exhibition-register-admin @finish="handleSubmit" />
    </div>
  </div>
</template>

<script>
import customFormType from "@/components/customForm/custom-form-type/custom-form-type.vue";
import exhibitionRegisterAdmin from "./components/exhibition-register-admin";
import { validator } from "@/other/validator";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "exhibition-register-company",
  data() {
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formInline.password) {
        callback(new Error("两次密码不匹配!"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      showModel: false,
      formInline: {
        // form双向绑定
        name: "",
        shortName: "",
        addr: ""
      },
      ruleInline: {
        // 效验规则
        name: [
          { required: true, message: "公司全称不能为空", trigger: "blur" },
          {
            type: "string",
            min: 4,
            message: "公司全称不能小于4位",
            trigger: "blur"
          },
          {
            type: "string",
            max: 50,
            message: "公司全称不能大于50位",
            trigger: "blur"
          }
        ],
        shortName: [
          {
            type: "string",
            max: 6,
            message: "公司简称不能大于6位",
            trigger: "blur"
          },
          { required: true, message: "公司简称不能为空", trigger: "blur" }
        ],
        addr: [{ required: true, message: "公司地址不能为空", trigger: "blur" }]
      },
      defaultList: [],
      imgName: "",
      visible: false,
      uploadList: [],
      formData: { extend: [], properties: [] }
    };
  },
  components: {
    exhibitionRegisterAdmin,
    customFormType
  },
  created() {
    document.title = "注册 - 公司信息";
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany"
    })
  },
  methods: {
    ...mapMutations({
      setCompany: "loginModule/setCompany"
    }),
    ...mapActions({
      addCompany: "companyModule/addCompany",
      getCompany: "loginModule/getCompany",
      bindEmailApply: "companyModule/bindEmailApply" // 验证并更改邮箱 绑定邮箱（原邮箱为空）
    }),
    async handleSubmit(data) {
      let name = "formInline";
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let logo = "";
      if (this.uploadList && this.uploadList.length) {
        logo = this.uploadList[0].url;
      } else {
        this.$Message.error("请上传公司logo");
      }
      let formData = {
        UserId: this.user.id,
        Name: data.name,
        CompName: form.name,
        ShortName: form.shortName,
        Address: form.addr,
        Logo: logo,
        Email: data.email,
        // BusMode: Number(this.formData.busMode) || '',
        Extend: this.formData.extend,
        Properties: this.formData.properties
      };
      if (this.user.agentId) {
        formData.AgentId = this.user.agentId;
      }

      this.loading = true;
      let user = await this.addCompany(formData).catch(
        e => (this.loading = false)
      );
      this.loading = false;
      if (!user) {
        this.$Message.error("保存失败，请重新尝试!");
        return false;
      }
      if (user.errors && user.errors[0]) {
        this.$Message.error(user.errors[0].description);
        return;
      }
      if (user.info) {
        let companyData = await this.getCompany(this.user.id);
        this.setCompany(companyData);
      } 
      // 绑定新邮箱
      let valid2 = await this.bindEmailApply({
        UserId: this.user.id,
        NewEmail: data.email,
        token: data.captcha
      }); 
      if (!valid2) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid2 && !valid2.successed) {
        this.$Message.error(valid2.msg);
        this.$router.push("/exhibition/index/home");
        return false;
      }
      if (valid2.errors && valid2.errors[0]) {
        if (valid2.errors[0].code === -1) {
          this.$Message.error("无效的验证码");
          return;
        }
        this.$Message.error(valid2.errors[0].description);
        return;
      }  
      this.$Message.success("绑定成功!");
      this.$Message.success("保存公司信息成功！");
      this.$router.push("/exhibition/template/choice-new?type=add");
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    // 上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove(file) {
      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
      }
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传jpg或者png格式的图片"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于2M的图片"
      });
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}张图片`
        });
      }
      return check;
    },
    back() {
      localStorage.clear();
      this.$router.push('/exhibition/login');
    }
  },
  mounted() {
    this.uploadList = this.$refs.upload.fileList;
  }
};
</script>

<style scoped lang='scss'>
.layout-box {
  padding-bottom: 20px;
  background: #fff;
  &.z-top {
    background: #fff;
    border-top: 10px solid #fafafa;
  }
}
.register-form {
  font-size: 14px;
  width: 650px;
  margin: 0 auto;
  .rf {
    &-title {
      font-size: 20px;
      color: #333;
      padding: 60px 0 44px;
      text-align: center;
    }
  }
  .form-code-item {
    .ivu-btn {
      margin-left: 10px;
      width: calc(100% - 10px);
    }
  }
  .form-tip-info {
    color: #1890ff;
    cursor: pointer;
  }
}

.layout-body {
  height: 100%;
  background: #fff;
}
.layout-header-bar {
  display: flex;
  background: #002140;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.head-logo {
  height: 64px;
  padding-top: 16px;
  padding-left: 19px;
}
.head-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.head-btn {
  font-size: 18px;
  color: #ededed;
  padding-right: 45px;
  display: inline-block;
  cursor: pointer;
}
</style>